import { Typography, Button } from 'antd';
import { FC } from 'react';

const { Title } = Typography;

const ComingSoon: FC = () => (
  <div style={{ padding: '50px' }}>
    <Title level={3}>Deze functionaliteit is nog niet beschikbaar</Title>
    <Button type="primary" onClick={() => window.history.back()}>
      Terug naar vorige pagina
    </Button>
  </div>
);

export default ComingSoon;
